import React from 'react';
import { cx } from '../cx';

// D-09 §15.35 — Card List (.card-list > .app-card | 임의 카드)
// 자식 비의존형 컨테이너. layout 변형(grid 기본 / column / row),
// grid 최소 칼럼폭은 --card-min(기본 240px)로 주입해 밀도 조절(포토=150 등).
export interface CardListProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 레이아웃 변형. 기본 'grid'(auto-fill) · 'grid-fit'(auto-fit, 적은 카드도 행 채움) · column · row */
  layout?: 'grid' | 'grid-fit' | 'column' | 'row';
  /** grid 최소 칼럼폭(px). --card-min 주입. 미지정 시 CSS 기본 240 */
  minColWidth?: number;
  /** 간격(px). 미지정 시 토큰 기본 16 */
  gap?: number;
}

export function CardList({
  layout = 'grid',
  minColWidth,
  gap,
  className = '',
  style,
  children,
  ...props
}: CardListProps) {
  const varStyle: React.CSSProperties = {
    ...(minColWidth != null ? ({ '--card-min': `${minColWidth}px` } as React.CSSProperties) : {}),
    ...(gap != null ? { gap: `${gap}px` } : {}),
    ...style,
  };
  return (
    <div
      className={cx('card-list', layout !== 'grid' && layout, className)}
      style={varStyle}
      {...props}
    >
      {children}
    </div>
  );
}
